// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1_N7h","cls2":"CitationModal-cls2_OVU CitationModal-cls1_N7h"};